const BYTES_PER_MEBIBYTE = 1024 * 1024

/**
 * Formats a byte count as a whole-megabyte label, e.g. `20 MB`. The API's limit is a round number of
 * mebibytes, so fractions are only shown when a config change makes them necessary.
 *
 * @param bytes A number of bytes.
 */
export function formatFileSizeLabel(bytes: number) {
	const megabytes = bytes / BYTES_PER_MEBIBYTE
	const rounded = Math.round(megabytes * 10) / 10
	return `${rounded} MB`
}
